// extracted by mini-css-extract-plugin
export var blockedMessage = "_af-3";
export var blockedOverlay = "_af-1";
export var fadeIn = "_af-2";
export var hereLink = "_af-0";
export var slideUp = "_af-4";